// @ts-nocheck
import "../../sass/pages/register.scss";
import 'aos/dist/aos.css';

import * as Bouncer from "formbouncerjs";
import { emails } from "../config/constants";

import moment from 'moment';
import * as Aos from "aos";
import SplitText from "../components/splitTexts";

window.addEventListener("load", () => {
  Aos.init({ once: true })
  validateRegisterForm();
  new SplitText(".st_formRegister-text")
  btnInfoCode();
});

function btnInfoCode() {
  const selectInfoCode = document.querySelector(".form-item-store-invoice select");
  selectInfoCode.addEventListener("change", e => {
    activeBtnInfoCode();
  })
}

function activeBtnInfoCode() {
  // const iconInfoCode = document.querySelector(".info_code");
  // const a = document.createElement("A");
  // a.classList.add("icon-info");
  // a.setAttribute("href", "#");
  // iconInfoCode.appendChild(a);

  const codeWrapper = document.querySelector(".mx-stella-hub-core-register-form");

  let observer = new MutationObserver(mutationRecords => {
    const observerWrapper = mutationRecords[0].target.querySelector('#code-wrapper');
    // const codeWrapper = document.querySelector("#code-wrapper");
    if(!observerWrapper?.children[2]) {
      const anchorIcon = document.createElement("A");
      anchorIcon.classList.add("icon-info");
      observerWrapper?.appendChild(anchorIcon);
    }

    anchorIcon.addEventListener("click", e => {
      e.preventDefault();
      document.querySelector(".modalCode").classList.remove("modalCodeHide");
    })
  
    const close = document.querySelector(".modalCode .modalCodeClose");
    close.addEventListener("click", e => {
      e.preventDefault();
      document.querySelector(".modalCode").classList.add("modalCodeHide");
    })
  });
  
  // observa todo exceptuando atributos
  observer.observe(codeWrapper, {
    childList: true, // observa hijos directos
    subtree: true, // y descendientes inferiores también
    characterDataOldValue: true // pasa el dato viejo al callback
  });
}

function validateRegisterForm() {

  const emailInput = document.querySelector("#edit-email")
  emailInput && emailInput.setAttribute("onkeyup", "javascript:this.value=this.value.toLowerCase();")
  const bouncer = Bouncer("form", {
    patterns: {
      email:
        /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
    },
    customValidations: {
      nameYlastname: function (field: any) {
        if (field.name == "first_name" || field.name == "last_name") {
          const value = field.value;
          if (value.match(/\d+/g)) {
            return true;
          }
        }
      },
      phone: function (field: any) {
        if (field.name == "phone") {
          const value = field.value;
          if (!value.match(/^[0-9]/)) {
            return true;
          }
          if (value.length < 7 || value.length > 10) {
            return true;
          }
        }
      },
      code: function (field: any) {
        if (field.name == "code_store_invoice") {
          if(field.closest('#code-wrapper').getAttribute('hidden') !== '') {
            const value = field.value;
            if (!value.match(/^[0-9,$]*$/)) {
              return true;
            }
            if (value.length < 6 || value.length > 21) {
              return true;
            }
          }
        }
      },
      zipcode: function (field: any) {
        if (field.name == "postal_code") {
          const value = field.value;
          if (value.length !== 5 ) {
            return true;
          }
        }
      },
      point3: function (field: any) {
        if (field.name == "point3") {
          const value = field.value;
          if (value.length > 280) {
            return true;
          }
        }
      },
      emailVerified: function (field: HTMLInputElement) {
        if (field.name == "email") {
          let array_email = field.value.split("@");
          const res = emails.find((m: any) => m === array_email[1]);
          return res === undefined ? false : true;
        }
      },
      emailExists: function (field: HTMLInputElement) {
        if (field.name == "email") {
          return field.classList.contains('email-exists');
        }
      },
      phoneExists: function (field: HTMLInputElement) {
        if (field.name == "phone") {
          return field.classList.contains('phone-exists');
        }
      },
      ageVerified: function (field: HTMLSelectElement) {
        if (field.name === "day") {
          const year = document.getElementById("edit-year").value;
          const month = document.getElementById("edit-month").value;
          const day = document.getElementById("edit-day").value;
          const age = getAge(year, month, day);

          if (age < 18) {
            return true;
          }
          return false;
        }
      },
      ageIsValid: function (field: HTMLSelectElement) {
        if (field.name === "day") {
          const year = document.getElementById("edit-year").value;
          const month = document.getElementById("edit-month").value;
          const day = document.getElementById("edit-day").value;

          const isValid = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD')
          // console.log(isValid);

          if (!isValid.isValid()) {
            return true;
          }
          return false;
        }
      },
    },
    messages: {
      missingValue: {
        checkbox: "Debe aceptar Términos y condiciones y Aviso de privacidad.",
        default: "Este campo es obligatorio",
      },
      emailVerified: "Por favor ingrese un email válido",
      emailExists: "Correo Electrónico ya se encuentra registrado",
      phoneExists: "Número de teléfono ya se encuentra registrado",
      nameYlastname: "No se permiten números",
      ageVerified: "Debe ser mayor de edad",
      ageIsValid: "Ingresa una fecha valida",
      phone: "Teléfono debe tener entre 7 y 10 dígitos",
      zipcode: "Código postal debe tener 5 dígitos",
      point3: "El limite es de 280 caracteres",
      code: "Campo inválido",
      patternMismatch: {
        email: "Por favor ingrese un email válido",
      },
    },
  });
}

function getAge(y: number, m: number, d: number) {
  const today = new Date();
  const birthDate = new Date(`${y}/${m}/${d}`);
  const age = today.getFullYear() - birthDate.getFullYear()
  const mo = today.getMonth() - birthDate.getMonth()
  if (mo < 0 || (mo === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

